import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { VisualizationProvider } from 'redhotmagma-visualization/VisualizationProvider';
import { AlignTargetProvider, withAlignTarget } from 'redhotmagma-visualization/AlignTargetProvider';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import sendMessage from '@configuratorware/configurator-frontendgui/Utils/Function/sendMessage';

const AlignTargetDisabler = withAlignTarget(({ alignTarget }) => {
  useEffect(() => {
    // skip adding align target
    alignTarget.add = () => {};
  }, [alignTarget]);
  return null;
});

export class CustomVisualizationProvider extends React.Component {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  };

  state = {
    visualization: null,
  };

  componentDidMount() {
    const visualization = Services.visualization.getComponent();
    this.setState({
      visualization,
    });
    sendMessage(Services.visualization, 'registerComponentChangeListener', this.onComponentChange);
  }

  onComponentChange = ({ data: { component } }) => {
    this.setState({ visualization: component });
  };

  render() {
    const { children } = this.props;
    const { visualization } = this.state;
    return (
      <VisualizationProvider visualization={visualization}>
        <AlignTargetProvider>
          <AlignTargetDisabler />
          {children}
        </AlignTargetProvider>
      </VisualizationProvider>
    );
  }
}
